module.exports={render:function (){var _vm=this;
  return _vm._h('main', [_vm._h('div', [_vm._h('v-container', [_vm._h('v-card', {}, [_vm._m(0), " ", _vm._h('iframe', {
    attrs: {
      "src": "https://docs.google.com/forms/d/e/1FAIpQLSdku7asj-prSaEg0YWi3DPks6ACtATcP1Gmjoow2srjIvoI6w/viewform?embedded=true",
      "width": "100%",
      "height": "1150",
      "frameborder": "0",
      "marginheight": "5",
      "marginwidth": "10px"
    }
  }, ["読み込んでいます..."])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "card-content"
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/svg/communication/writing.svg",
      "style": "height: 40px;"
    }
  }), " ", _vm._h('span', {
    staticClass: "card-title",
    attrs: {
      "style": "vertical-align:top;"
    }
  }, ["\n            お問合せ\n          "])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2075ccde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Contact.vue
// module id = 51
// module chunks = 2